/*
 * Constants to represent the names of Plan Builder filter methods.
 */
const FILTER_NAMES = {
    aim4SapC: 'aim4SapC',
    aim4ZeroCarbon: 'aim4ZeroCarbon',
    alternativesTo: 'alternativesTo',
    improveEpc: 'improveEpc',
    mostEfficient: 'mostEfficient',
    recommended: 'recommended',
    reduceCo2Emissions: 'reduceCo2Emissions',
    reduceFuelBill: 'reduceFuelBill',
    withinBudget: 'withinBudget',
}

/**
 * All available filters as an array.
 * @type {Array<string>}
 */
const ALL_FILTERS = [
    FILTER_NAMES.aim4SapC,
    FILTER_NAMES.aim4ZeroCarbon,
    FILTER_NAMES.alternativesTo,
    FILTER_NAMES.improveEpc,
    FILTER_NAMES.mostEfficient,
    FILTER_NAMES.recommended,
    FILTER_NAMES.reduceCo2Emissions,
    FILTER_NAMES.reduceFuelBill,
    FILTER_NAMES.withinBudget,
]

/**
 * Valid filters to use with motivations as an array.
 * @type {Array<string>}
 */
const MOTIVATION_FILTERS = [
    FILTER_NAMES.aim4SapC,
    FILTER_NAMES.aim4ZeroCarbon,
    FILTER_NAMES.improveEpc,
    FILTER_NAMES.mostEfficient,
    FILTER_NAMES.reduceCo2Emissions,
    FILTER_NAMES.reduceFuelBill,
]

export { ALL_FILTERS, MOTIVATION_FILTERS }

export default FILTER_NAMES
